const SET_CLIENT_LIST = '@client/set-client-list';
const SET_CLIENT_DETAIL = '@client/set-client-detail';
const SET_CLIENT_LIST_TOTAL = '@client/set-client-list-total';

export {SET_CLIENT_LIST, SET_CLIENT_DETAIL, SET_CLIENT_LIST_TOTAL};
